import {
  GET_ALL_COMPANION_CONFIG_VERSION_DETAILS,
  COMPANION_CONFIG_VERSION_IS_LOADING,
  COMPANION_CONFIG_VERSION_ERROR,
  SET_COMPANION_CONFIG_VERSION_CURRENT_PAGE,
  SET_COMPANION_CONFIG_VERSION_CHANGE,
  UPDATE_COMPANION_CONFIG_VERSION_SAVE_STATUS,
  COMPANION_CONFIG_VERSION_SAVE_ERROR,
  SET_COMPANION_CONFIG_VERSION_DETAILS
} from '../constants/index';
import { initialCompanionConfigVersionState } from './initialState';

const companionConfigVersionReducer = (state = initialCompanionConfigVersionState, action) => {
  const { payload, type } = action;
  switch (type) {
    case GET_ALL_COMPANION_CONFIG_VERSION_DETAILS: {
      const { data } = payload;
      return {
        ...state,
        companionConfigVersionManager: {
          ...state.companionConfigVersionManager,
          ...data
        }
      };
    }

    case COMPANION_CONFIG_VERSION_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        companionConfigVersionManager: {
          ...state.companionConfigVersionManager,
          isLoading: isLoading,
          // Clear any previous error the moment a new load (including a
          // retry) starts, so the error panel drops away while the spinner
          // shows rather than lingering underneath it.
          hasLoadError: isLoading ? false : state.companionConfigVersionManager.hasLoadError
        }
      };
    }

    case COMPANION_CONFIG_VERSION_ERROR: {
      const { data } = payload;
      return {
        ...state,
        companionConfigVersionManager: {
          ...state.companionConfigVersionManager,
          ...data
        }
      };
    }

    case SET_COMPANION_CONFIG_VERSION_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        companionConfigVersionManager: {
          ...state.companionConfigVersionManager,
          currentPage
        }
      };
    }

    // BCC-18: add-form cases below. SET_COMPANION_CONFIG_VERSION_CHANGE is
    // used both for live field edits and the reset-on-unmount cleanup (same
    // dual-purpose convention as SET_MODEL_FIRMWARE_VERSION_CHANGE).
    case SET_COMPANION_CONFIG_VERSION_CHANGE: {
      const { selectedCompanionConfigVersion } = payload;
      return {
        ...state,
        companionConfigVersionManager: {
          ...state.companionConfigVersionManager,
          selectedCompanionConfigVersion
        }
      };
    }

    case UPDATE_COMPANION_CONFIG_VERSION_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        companionConfigVersionManager: {
          ...state.companionConfigVersionManager,
          ...data
        }
      };
    }

    case COMPANION_CONFIG_VERSION_SAVE_ERROR: {
      const { data } = payload;
      return {
        ...state,
        companionConfigVersionManager: {
          ...state.companionConfigVersionManager,
          ...data
        }
      };
    }

    // Edit: describe result replaces selectedCompanionConfigVersion wholesale,
    // same as SET_MODEL_FIRMWARE_VERSION_DETAILS.
    case SET_COMPANION_CONFIG_VERSION_DETAILS: {
      const { selectedCompanionConfigVersion } = payload;
      return {
        ...state,
        companionConfigVersionManager: {
          ...state.companionConfigVersionManager,
          selectedCompanionConfigVersion: selectedCompanionConfigVersion
            ? selectedCompanionConfigVersion
            : state.companionConfigVersionManager.selectedCompanionConfigVersion,
          isLoading: false
        }
      };
    }

    default:
      return state;
  }
};

export default companionConfigVersionReducer;
